import { connect } from 'react-redux';
import { selectOrdersGridPage, selectOrdersGridPageSize } from '../../store/orders/grid/orders.grid.selectors';
import { PagingContextProvider } from './index';

const mapStateToProps = (state, { pageSelector = selectOrdersGridPage, pageSizeSelector = selectOrdersGridPageSize }) => {
  const page = pageSelector(state);
  const pageSize = pageSizeSelector(state);

  return {
    page,
    pageSize,
  };
};

export const PagingContextProviderContainer = connect(mapStateToProps)(PagingContextProvider);
